// extracted by mini-css-extract-plugin
module.exports = {"root":"Confirm_root__2aInI","text":"Confirm_text__2j5J8","buttons":"Confirm_buttons__3hUzE"};